import { styled, Typography, Stack, type CSSObject } from '@mui/material';

export const StyledContent = styled(Stack)(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(8),
  margin: theme.spacing(8, 0, 0, 0),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(4),
    margin: theme.spacing(4, 0, 0, 0),
    flexDirection: 'column',
  },
}));

export const StyledTextContainer = styled(Stack)(({ theme }) => ({
  width: '63%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    gap: theme.spacing(1),
    width: '100%',
  },
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  ...(theme.mixins.neutralGradient as CSSObject),
  backgroundClip: 'text',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  paddingBottom: theme.spacing(0.5),
}));
export const StyledDescription = styled(Typography)(({ theme }) => ({
  color: theme.palette.invertedContent?.PRIMARY,
}));
